<section class="banner-section specificTools editing-jp">
    <div class="container">
        <div class="row no-margin">
            <div class="col-lg-12 no-padding">
                <app-english-grammar-checker></app-english-grammar-checker>
            </div>
        </div>
    </div>
</section>